import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

/* State shape
{
    loadingState: {
        isLoading: bool,
        success: bool,
        error: Array
    },
    playersState: {
        players: Object,
    }
}
*/

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_PLAYERS)(actionTypes.PLAYERS_RESPONSE);

const playersReducer = (state = {}, action) => {
    const { payload } = action;

    if (action.type === actionTypes.PLAYERS_RESPONSE) {
        return Object.assign({}, state, {[payload.teamId]: payload.players});
    } else if (action.type === actionTypes.FLUSH_CACHE) {
        if (payload.teamId) {
            return Object.assign({}, state, {[payload.teamId]: []});
        }
        return {};
    }

    return state;
};

const playersStateReducer = combineReducers({
    players: playersReducer
});


const reducer = combineReducers({
    loadingState: loadingStateReducer,
    playersState: playersStateReducer
});

export default reducer;